import 'css-chunksrc/client/common/taskStatus/styles.scss';export default {
  "taskStatus": "_taskStatus_s7t8z_1",
  "name": "_name_s7t8z_7"
};